import { createFileRoute, redirect } from '@tanstack/react-router';

import { AdminPage } from '@/features/admin/admin-page';
import { sessionQueryOptions } from '@/features/auth/api';

/** Admins only; others land on the home page (the API refuses them anyway). */
export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.query({
      ...sessionQueryOptions,
      staleTime: 'static',
    });
    if (session.user.role !== 'admin') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirects are thrown
      throw redirect({ to: '/' });
    }
  },
  component: AdminPage,
});
